import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card, Button } from 'react-bootstrap'; // Assuming you're using Bootstrap for the card, dropdown, and button components
import UttamKalakarFooter from './UttamKalakarFooter';

const ReviewCheckedArticle = () => {
    const [user, setUser] = useState(null);
    const [titlesList, setTitlesList] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [reviewstatus, setReviewStatus] = useState('');


    useEffect(() => {
        const fetchTitles = async () => {
            try {
                const loggedInUser = sessionStorage.getItem('loggedInUser');
                console.log('loggedInUser:', loggedInUser);

                const response = await axios.get(`https://nrdruhs.in/api/manuscriptReviewChecked`, {
                    params: {
                        reviewby: user, // Pass the user's name as reviewby
                    },
                });
                setTitlesList(response.data.titles);
                console.log("titlesList:", response.data.titles); // ✅ HERE
            } catch (error) {
                console.error('Error fetching titles:', error.message);
            }
        };

        fetchTitles();
    }, [user]); // Add user to the dependency array to trigger the effect when user changes

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const isAuthenticated = sessionStorage.getItem('token');
                const response = await axios.get('https://nrdruhs.in/userdashboard', {
                    headers: {
                        Authorization: `Bearer ${isAuthenticated}`,
                    },
                });
                setUser(response.data.name);
                console.log('User data:', response.data.name);
            } catch (error) {
                console.error('Error fetching user data:', error.message);
            }
        };

        fetchUser();
    }, []);

    const handleDownloadArticle = async () => {

        if (!selectedTitle) {
            return Swal.fire('Warning', 'Select article first', 'warning');
        }

        const fileName = selectedTitle.reviewedarticle || selectedTitle.maindocument;

        if (!fileName) {
            return Swal.fire('Warning', 'No file available', 'warning');
        }

        try {
            const response = await axios({
                url: `https://nrdruhs.in/uploads/${fileName}`,
                method: 'GET',
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Download failed', 'error');
        }
    };


    const handleTitleChange = (e) => {
        const selected = titlesList.find(
            t => t.articleid.toString() === e.target.value
        );

        console.log("Selected Title FULL:", selected); // ✅ HERE

        setSelectedTitle(selected);
    };

    const handleFeedbackReviewStatus = async () => {
        if (!selectedTitle || !reviewstatus) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select article and status'
            });
            return;
        }

        try {
            // ✅ Update review status in DB
            await axios.put('https://nrdruhs.in/api/updateReviewStatus', {
                articleid: selectedTitle.articleid,
                reviewstatus: reviewstatus
            });

            // ✅ Send email to author
            await sendEmailToAuthor();

        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to update review status'
            });
        }
    };



    const sendEmailToAuthor = async () => {

        if (!selectedTitle || !selectedTitle.author_email) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Author email not found'
            });
            return;
        }

        const message = `Hello Author,

Your Article has been reviewed.

Review Status: ${reviewstatus}

Reviewer Feedback:
${selectedTitle.reviewfeedback}

Thanks
Web Administrator`;

        try {
            await axios.post('https://nrdruhs.in/sendemailtoreviewauthor', {
                email: selectedTitle.author_email,
                message: message
            });

            Swal.fire({
                icon: 'success',
                title: 'Email Sent',
                text: 'Feedback sent to Author successfully'
            });

        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div>
            <div className="main-content">
                <img
                    src="/assets/NRDRUHSHomeBanner.jpg"
                    alt="Background"
                    className="header-image"
                    style={{ width: '100%', height: '60vh', objectFit: 'cover' }}
                />
            </div>

            <div style={{ marginTop: 90, marginBottom: 90 }}>
                <Card style={{ margin: '0 auto', maxWidth: 600, background: 'linear-gradient(to right, #5433ff, #20bdff, #a5fecb)' }}>
                    <Card.Body>
                        <h3 style={{ textAlign: 'center', padding: 15, fontWeight: 'bold', fontSize: 18 }}>Review Completed Manuscripts</h3>
                        <div className="col-sm-12">
                            <select
                                className="form-select form-select-lg mb-3 mb-lg-0"
                                value={selectedTitle ? selectedTitle.articleid : ''}
                                onChange={handleTitleChange}
                            >
                                <option value="">Select a title</option>

                                {titlesList.map((titleObject) => {
                                    const displayTitle = titleObject.title.length > 66
                                        ? `${titleObject.title.substring(0, 66)}...`
                                        : titleObject.title;

                                    return (
                                        <option
                                            key={titleObject.articleid}
                                            value={titleObject.articleid}   // ✅ FIXED
                                        >
                                            {displayTitle} - {titleObject.articleid}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Card.Body>
                </Card>


                {selectedTitle && (
                    <div className="mt-4" style={{ marginLeft: 30, marginRight: 30 }}>
                        <Card>
                            <Card.Body>
                                <h5 className="card-title" style={{ textAlign: 'center' }}>Review Feedback</h5>
                                <p className="card-text" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                                    {selectedTitle.reviewfeedback}
                                </p>
                            </Card.Body>
                        </Card>
                    </div>
                )}




                <div style={{
                    width: '50%',
                    margin: '0 auto'
                }}>
                    <div className="form-group" style={{marginTop: 45}}>
                        <label htmlFor="reviewstatus" style={{ fontWeight: 'bold' }}>
                            Review Status
                        </label>

                        <select
                            id="reviewstatus"
                            className="form-control"
                            value={reviewstatus}
                            onChange={(e) => setReviewStatus(e.target.value)}
                            required
                        >
                            <option value="">Select Status</option>
                            <option value="Accepted">Accepted</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Corrections Needed">Corrections Needed</option>
                        </select>
                    </div>
                </div>



                <div className="text-center mt-3" style={{ margin: 45 }}>
                    <Button
                        variant="primary"
                        onClick={handleFeedbackReviewStatus}
                        disabled={!selectedTitle || !reviewstatus}
                    >
                        Send Feedback to Author
                    </Button>
                </div>

                <div className="text-center mt-3" style={{ margin: 45 }}>
                    <Button variant="primary" onClick={handleDownloadArticle}>
                        Download Article
                    </Button>
                </div>

            </div>

            <UttamKalakarFooter />
            <div className="row" style={{ height: 60, margin: 0, background: 'black' }}>
                <p className="copyright" style={{ fontSize: 15, color: '#999', textAlign: 'center', paddingTop: 18 }}>Copyrights © NRD RUHS Jaipur</p>
            </div>
        </div>
    );
};

export default ReviewCheckedArticle;
